<div [@routerTransition]>



  <div class="row">

    <div class="modal-body padding-top-0px padding-bottom-0px">

      <ul *ngIf="PatientTypedata=='Registered'" class="nav nav-tabs nav-tab-service2 margin-top-13px margin-left-15px margin-right-15px" id="tabContent">
        <li class="active margin-right-15px margin-left-15px margin-top-auto margin-bottom-auto"><a class="nav-itemerp active" href="#Vendor" data-toggle="tab">New OP BILL</a></li>
        <li class="margin-right-15px margin-top-auto margin-bottom-auto"><a class="nav-itemerp" href="#Material" data-toggle="tab">New RX BILL</a></li>

      </ul>

      <ul *ngIf="PatientTypedata=='Guest'" class="nav nav-tabs nav-tab-service2 margin-top-13px margin-left-15px margin-right-15px" id="tabContent2">
        <li class="margin-right-15px"><a class="nav-itemerp active" href="#Material" data-toggle="tab">New RX BILL</a></li>

      </ul>

      <div *ngIf="PatientTypedata=='Registered'" class="tab-content">
        <div class="tab-pane active" id="Vendor">
          <div *canUserAccess="['HL_BL_29']"><!-- access to  bill without service provider  -->
            <receiptold marginTop="0" FromScreen="CommonBilling" [FormattedCode2]="FormattedCode"></receiptold>
          </div>
          <div *canUserAccess="['HL_BL_30']"> <!-- access to bill with service provider -->
            <receipt_svcprovider marginTop="0" FromScreen="CommonBilling"
                                [FormattedCode2]="FormattedCode"></receipt_svcprovider>
          </div>
        </div>
        <div class="tab-pane" id="Material">
          <rxreceipt marginTop="0" FromScreen="CommonBilling" [FormattedCode2]="FormattedCode" [PatientType2]="PatientTypedata"></rxreceipt>
        </div>

      </div>
      <div *ngIf="PatientTypedata=='Guest'" class="tab-content2">
        <div class="tab-pane active" id="Material">
          <rxreceipt marginTop="0" FromScreen="CommonBilling" [FormattedCode2]="FormattedCode" [PatientType2]="PatientTypedata"></rxreceipt>
        </div>

      </div>


    </div>

    
  </div>
      <!--op bills-->

    </div>
